import { ReactNode, createContext, useMemo } from 'react';
import useAuth from '~/hooks/useAuth';
import { Permissions } from '../@types/user';

const initialState: Permissions = {
  role: {
    toChange: false,
  },
  user: {
    privateLists: {
      toRead: false,
    },
    toMasquarade: false,
  },
  support: {
    toProxy: false,
  },
};

const PermissionContext = createContext(initialState);

type PermissionProviderProps = {
  children: ReactNode;
};

function PermissionProvider({ children }: PermissionProviderProps) {
  const { user } = useAuth();
  const role = user?.attributes?.role;

  const isManager = role === 'manager';
  const isSupportEmployee = user?.attributes?.support_employee ?? false;

  const isAllowed = useMemo(
    () => ({
      role: {
        toChange: isManager,
      },
      user: {
        privateLists: {
          toRead: isManager,
        },
        toMasquarade: isManager,
      },
      support: {
        toProxy: isSupportEmployee,
      },
    }),
    [isManager, isSupportEmployee]
  );

  return <PermissionContext.Provider value={isAllowed}>{children}</PermissionContext.Provider>;
}

export { PermissionProvider, PermissionContext };
